


import axios from 'axios'

export const downLink = (url, name) => {
  let a = document.createElement('a')
  if (name) {
    a.download = name
  }
  a.href = url
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

/**
 * 通过axios请求文件流下载，避免被浏览器拦截弹窗
 * @param {string} url - 文件下载地址
 * @param {string} [fileName] - 自定义文件名，未传入时从url中解析
 * @returns {Promise<void>}
 */
export const downloadFileByBlob = (url, fileName) => {
  return axios.get(url, {
    responseType: 'blob',
    timeout: 3000 * 1000
  }).then(response => {
    if (response.status !== 200) {
      throw new Error('下载失败')
    }
    const blob = new Blob([response.data])
    const finalFileName = fileName || decodeURIComponent(url.split('/').pop())
    const linkNode = document.createElement('a')
    linkNode.style.display = 'none'
    linkNode.href = URL.createObjectURL(blob)
    linkNode.download = finalFileName
    document.body.appendChild(linkNode)
    linkNode.click()
    URL.revokeObjectURL(linkNode.href)
    document.body.removeChild(linkNode)
  }).catch(error => {
    console.error('文件下载失败:', error)
    throw error
  })
}

export const formateTime = (value) => {
  let result = parseInt(value)
  if (isNaN(result)) {
    return '--'
  }
  let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
  let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
  let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

  let res = `${h}:${m}:${s}`;

  return res;
}
export const formateTime2 = (value) => {
  let result = parseInt(value)
  if (isNaN(result)) {
    return '--'
  }
  let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
  let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
  let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
  let time = `${s}秒`
  if (Number(m) > 0) {
    time = `${m}分${time}`;
  }
  if (Number(h) > 0) {
    time = `${h}小时${time}`;
  }


  return time;
}
// 公式解析
export const $MathJax = () => {
  window.MathJax && window.MathJax.typeset && window.MathJax.typeset();
}

// officeweb365预览地址
// 使用文档 https://officeweb365.com/Help/Default/3
export const getOfficeWeb365Path = (path) => {
  let name = path.split('/').pop().split('?')[0]
  let draw = ''
  let fileType = name.split('.').pop()
  if (['pptx', 'ppt'].includes(fileType)) {
    draw = '&draw=1'
  }
  return `https://ow365.cn/?i=9945${draw}&furl=http://officeweb.zy.com/zy-office-web/zy_cos/office_view/cos/view?path=${path}&name=${name}`
}

export const questionTemplateList = [{
  id: "01",
  name: "单选题",
  defaultScore: 2,
},
{
  id: "02",
  name: "多选题",
  defaultScore: 3,
},
{
  id: "03",
  name: "填空题",
  defaultScore: 2,
},
{
  id: "04",
  name: "判断题",
  defaultScore: 1,
},
{
  id: "06",
  name: "主观题",
  defaultScore: 10,
}]

// 日志上传
export const netLogEvent = (clickId,eventId,eventName,value) => {
  console.log('clickId,eventId,eventName,value: ', clickId,eventId,eventName,value);
  try {
    const env = process.env.NODE_ENV
    _zyn.push([clickId, eventId, eventName, JSON.stringify({env, ...value})]);
  } catch (err) {
    console.log(err)
  }
}

// 判断客户端
export const isWxWork = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  const reg = /wxwork/g
  return reg.test(userAgent)

}

/* 重定向跳转 */
export function locationReplace(url) {
  if (history.replaceState) {
    history.replaceState(null, document.title, url)
    history.go(0)
  } else {
    location.replace(url)
  }
}

import orangeMode from '@/utils/orangeMode'
// 后端提供的跳转方法
export function getJumpPath (targetUrl) {
  
  const origin = new URL(targetUrl).origin;
  
  let targetOrigin;
  if (/pm/i.test(targetUrl)) {
    targetOrigin = origin + '/pm'
  } else {
    targetOrigin = origin + '/sc'
  }
  let currentHost = location.host; // jx.gaofen.com
  let targetHost = targetOrigin.replace('https://', '');  // sc.gaofen.com
  let dst = encodeURIComponent(targetUrl);
  let toPath = encodeURIComponent(targetHost+"/login?token=<token>&dst="+dst);
  let jumpPath = `https://${currentHost}/b/orangeJump?toPath=${toPath}`
  console.log(jumpPath)
  return jumpPath;
}